import { Box } from "@mui/material";
import { formatLabel } from "@/utils/format-label";

const getCategoryColor = (category) => {
  switch (category) {
    case "authentication":
      return { bg: "#eff6ff", color: "#1e40af", dot: "#3b82f6" };
    case "transaction":
      return { bg: "#ecfdf5", color: "#065f46", dot: "#10b981" };
    case "kyc":
      return { bg: "#faf5ff", color: "#6b21a8", dot: "#a855f7" };
    case "profile":
      return { bg: "#fff7ed", color: "#9a3412", dot: "#f97316" };
    case "product":
      return { bg: "#f0f9ff", color: "#075985", dot: "#0ea5e9" };
    default:
      return { bg: "#f3f4f6", color: "#374151", dot: "#9ca3af" };
  }
};

const getStatusColor = (status) => {
  switch (status) {
    case "success":
      return { bg: "#ecfdf5", color: "#065f46" };
    case "failed":
      return { bg: "#fef2f2", color: "#991b1b" };
    case "pending":
      return { bg: "#fffbeb", color: "#92400e" };
    default:
      return { bg: "#f3f4f6", color: "#374151" };
  }
};

export const CustomerActivityColumns = [
  {
    accessorKey: "timestamp_formatted",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date & Time</div>,
    cell: ({ row }) => (
      <div
        style={{ fontSize: "0.85rem", whiteSpace: "nowrap", color: "#6b7280" }}
      >
        {row.original.timestamp_formatted ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "activity",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Activity</div>,
    cell: ({ row }) => {
      const category = row.original.category;
      const { dot } = getCategoryColor(category);
      return (
        <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: dot,
              flexShrink: 0,
              marginTop: 5,
            }}
          />
          <div>
            <div
              style={{
                fontSize: "0.85rem",
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              {row.original.activity ?? "N/A"}
            </div>
            <div
              style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 2 }}
            >
              {row.original.description ?? ""}
            </div>
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: "category",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category</div>,
    cell: ({ row }) => {
      const category = row.original.category;
      if (!category) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
      const { bg, color } = getCategoryColor(category);
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: bg,
            color: color,
            fontSize: "0.8rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {row.original.category_label ?? formatLabel(category)}
        </Box>
      );
    },
  },
  {
    accessorKey: "ip_address",
    header: () => <div style={{ whiteSpace: "nowrap" }}>IP Address</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", fontFamily: "monospace" }}>
        {row.original.ip_address ?? "—"}
      </div>
    ),
  },
  {
    accessorKey: "channel",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Channel</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>{row.original.channel ?? "N/A"}</div>
    ),
  },
  {
    accessorKey: "status",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const status = row.original.status;
      if (!status) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
      const { bg, color } = getStatusColor(status);
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: bg,
            color: color,
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          {formatLabel(status)}
        </Box>
      );
    },
  },
];
